import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home';
import Driver from '@/pages/DriverView';
import Lad from '@/pages/LADView';
import LadHome from '@/pages/LADListing';
import Login from '@/pages/Login';
import auth from '@/utils/auth';


Vue.use(Router);

function redirectToDefaultPage(next) {
  if (auth.isLogged()) {
    next();
  } else {
    console.log('not logged');
    next({ name: 'Login' });
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/driver/:id',
      name: 'driver',
      component: Driver,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/parsers',
      name: 'ladHome',
      component: LadHome,
      props: true,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/new-parser',
      name: 'ladCreate',
      component: Lad,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/update-parser',
      name: 'ladUpdate',
      component: Lad,
      props: true,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js